import React, { useEffect, useRef } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Title, Legend, ChartDataLabels);

export function ExportTIMChartV({
  questions,                 // ← array [{positive, negative, question}]
  onImageReady,
  positiveColor = "#69AF45",
  negativeColor = "#2B8DCC",
  graphHeight = 260,
  graphWidth = 800,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!ref.current) return;

      const canvas = ref.current.canvas || ref.current.ctx?.canvas;
      if (!canvas) return;

      const tempCanvas = document.createElement("canvas");
      const scale = 2;
      tempCanvas.width = canvas.width * scale;
      tempCanvas.height = canvas.height * scale;

      const ctx = tempCanvas.getContext("2d");
      ctx.scale(scale, scale);
      ctx.drawImage(canvas, 0, 0);

      const url = tempCanvas.toDataURL("image/png", 1.0);
      onImageReady && onImageReady(url);
    }, 400);

    return () => clearTimeout(timeout);
  }, [questions, onImageReady]);

  // Q1, Q2, Q3...
  const labels = questions.map((_, idx) => `Q${idx + 1}`);
  const positives = questions.map((q) => q.positive);
  const negatives = questions.map((q) => q.negative);

  const chartData = {
    labels, // ["Q1","Q2",...]
    datasets: [
      {
        label: "Positive",
        data: positives,
        backgroundColor: positiveColor,
      },
      {
        label: "Negative",
        data: negatives,
        backgroundColor: negativeColor,
      },
    ],
  };

  const options = {
    indexAxis: "x",  // vertical
    responsive: false,
    animation: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "rectRounded",
          padding: 10,
          font: { size: 10 },
        },
      },
      tooltip: { enabled: false },
      datalabels: {
        color: "#FFFFFF",                    // color blanco
        font: { size: 10 },
        anchor: "center",
        align: "center",
        formatter: (value) => {
          if (!value || value === 0) return "";
          return `${value}%`;               // con símbolo de porcentaje
        },
      },
      title: { display: false },
    },
    scales: {
      x: {
        type: "category",
        ticks: {
          font: { size: 10, weight:"bold" },
        },
        grid: {
          display: true,
          color: "#105385",  // más oscura
          lineWidth: 1.2,            // más gruesa
          drawOnChartArea: true,
          drawTicks: false,
          offset: true,              // ayuda a alinear con los grupos
        },
      },
      y: {
        type: "linear",
        min: 0,
        max: 100,
        ticks: {
          stepSize: 25,
          callback: (value) => `${value}%`,
          font: { size: 10 },
        },
      },
    },
  };

  return (
    <Bar
      ref={ref}
      data={chartData}
      options={options}
      width={graphWidth}
      height={graphHeight}
    />
  );
}